var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17854 1.60693H10.7857C11.0698 1.60693 11.3424 1.71982 11.5433 1.92075C11.7442 2.12168 11.8571 2.3942 11.8571 2.67836V13.3926C11.8571 13.6768 11.7442 13.9493 11.5433 14.1503C11.3424 14.3512 11.0698 14.4641 10.7857 14.4641H2.21425C1.93009 14.4641 1.65757 14.3512 1.45664 14.1503C1.2557 13.9493 1.14282 13.6768 1.14282 13.3926V2.67836C1.14282 2.3942 1.2557 2.12168 1.45664 1.92075C1.65757 1.71982 1.93009 1.60693 2.21425 1.60693H3.8214",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10699 0.535645H4.89271C4.30098 0.535645 3.82129 1.01534 3.82129 1.60707V2.14279C3.82129 2.73452 4.30098 3.21422 4.89271 3.21422H8.10699C8.69872 3.21422 9.17842 2.73452 9.17842 2.14279V1.60707C9.17842 1.01534 8.69872 0.535645 8.10699 0.535645Z",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82129 5.89258H9.17842",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82129 8.57129H9.17842",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.82129 11.25H9.17842",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.e634b0fa27ea091f421e1eae8c6fdbde.svg";
export { ForwardRef as ReactComponent };